import styled from "styled-components"
import { theme } from "Theme"
import { mixins } from "Styles"

export const Grid = styled.div`
  margin: 1rem auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(20%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns: repeat(auto-fill, minmax(13%, 1fr));
  }
  grid-gap: 16px;
`

export const Card = styled.div`
  background: ${theme.colors.white.base};
  border-radius: ${theme.borderRadius.elements};
  box-shadow: ${theme.shadow.feature.big.default};
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: all 0.4s;
  &:hover {
    transform: scale(1.02);
  }
  @media (min-width: ${theme.breakpoints.s}) {
  }
`

export const Avatar = styled.div`
  background-image: url(${(props) => props.background});
  background-position: top;
  background-repeat: no-repeat;
  background-color: #888;
  height: 180px;
  background-size: cover;
  width: 100%;
  border-radius: ${theme.borderRadius.ui} ${theme.borderRadius.ui} 0 0;
  position: relative;
  overflow: hidden;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    height: 160px;
  }
  @media (min-width: ${theme.breakpoints.l}) {
    background-size: cover;
  }
  ${mixins.backgroundAvatar};
`

export const Name = styled.h5`
  color: ${theme.colors.primary.base};
  font-size: ${theme.fontSize.small};
  font-weight: bold;
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  color: white;
  z-index: 10;
  margin: 0;
`

export const Title = styled.p`
  color: ${theme.colors.black.base};
  font-size: ${theme.fontSize.xsmall};
  margin: 0;
`

export const Company = styled.p`
  color: ${theme.colors.black.base};
  font-size: ${theme.fontSize.smallish};
  font-weight: bold;
  margin: 0;
`

export const Speaker = styled.div`
  width: 100%;
  text-align: left;
  background: #fff;
  border-radius: ${theme.borderRadius.ui};
  overflow: hidden;
  box-shadow: ${theme.shadow.feature.small.default};
  border: 1px solid #ddd;
  height: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

export const Content = styled.div`
  width: 100%;
  text-align: left;
  height: 100%;
  padding: 8px;
  background: ${theme.colors.white.base};
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  margin: 0;
  position: absolute;
  top: 8px;
  left: 8px;
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`
